// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"470":"c4c03767","992":"5aa7caa1"}[chunkId] + ".chunk.js";
};